/**
 * Fired from `job.client.ts` after the interactive `#job-app` tree is shown.
 * Layout uses this to remove the SSR shell when React manages `#root` (client navigation).
 * On first job load, `onRenderClient` skips hydrating `#root`, so the shell is removed via DOM `remove()` instead.
 */
export const JOB_ISLAND_SWAPPED_EVENT = 'job-island-swapped';
